import { render, staticRenderFns } from "./tablaSimple.vue?vue&type=template&id=7b4f7b70"
import script from "./tablaSimple.vue?vue&type=script&lang=js"
export * from "./tablaSimple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports